import React, { useState } from 'react';

interface CollapsibleSectionProps {
  title: string;
  count: number;
  defaultOpen?: boolean;
  children: React.ReactNode;
}

export const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  title,
  count,
  defaultOpen = false,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="bulk-edit-modal__collapsible">
      <button className="bulk-edit-modal__collapsible__header" onClick={() => setIsOpen(!isOpen)} type="button">
        <i className={`icon icon-arrow_down ${!isOpen ? 'collapsed' : ''}`} />
        <span>
          {title} ({count})
        </span>
      </button>
      {isOpen && <div className="bulk-edit-modal__collapsible__content">{children}</div>}
    </div>
  );
};
